import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Snowflake, Pill, GlassWater, HardHat, Flame, 
  ShieldCheck, MapPin
} from 'lucide-react';

import { sendWhatsAppNotification } from '../utils/whatsapp';

const SpecialLogistics = () => {
  const navigate = useNavigate();

  const n8nUrl = "http://localhost:5678/webhook/apni-manzil-logistics";

  const handleSpecialBooking = async (serviceTitle) => {
    const customerPhone = "7378502356"; 
    const customerName = "Special Logistics Client";
    const orderId = "SPEC-" + Math.floor(Math.random() * 100000);

    const bookingData = {
      customerName,
      customerPhone,
      serviceTitle,
      orderId,
      timestamp: new Date().toISOString()
    };

    sendWhatsAppNotification(customerPhone, customerName, serviceTitle, orderId);
  
    try {
      await fetch(n8nUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bookingData),
      });
    } catch (error) {
      console.error("Webhook error:", error);
    }
  
    alert(`${serviceTitle} enquiry has been sent successfully!`);
  };

  const specialServices = [
    {
      id: 1,
      title: "Cold Chain Logistics",
      desc: "Temperature Controlled shipping for perishables.",
      icon: <Snowflake size={40} className="text-blue-500" />,
      tag: "Book Now" 
    },
    {
      id: 2,
      title: "Medicine Transport",
      desc: "Safe Delivery of Medicines and Vaccines.",
      icon: <Pill size={40} className="text-red-500" />,
      tag: "Book Now"
    },
    {
      id: 3,
      title: "Fragile Item Shipping",
      desc: "Safe Delivery of Fragile & Delicate Goods.",
      icon: <GlassWater size={40} className="text-amber-500" />,
      tag: "Explore"
    },
    {
      id: 4,
      title: "Heavy Machinery Transport",
      desc: "Safe Transport of Heavy Equipment & Plants.",
      icon: <HardHat size={40} className="text-slate-700" />,
      tag: "Explore"
    },
    {
      id: 5,
      title: "Dangerous Goods Transport",
      desc: "Certified handling for hazardous materials.",
      icon: <Flame size={40} className="text-orange-600" />,
      tag: "Explore"
    }
  ];

  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      
      {/* 1. HERO SECTION (Blue Header) */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white py-16 px-6 relative overflow-hidden">
         <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between relative z-10">
            <div className="text-left space-y-4">
               <p className="text-sm font-bold opacity-80 uppercase tracking-widest">Home / Special Logistics</p>
               <h1 className="text-3xl sm:text-5xl md:text-6xl font-black tracking-tight">Special <span className="text-yellow-400">Logistics</span></h1>
               <p className="text-xl font-bold opacity-90">Special Handling Delivery</p>
            </div>
            <div className="hidden md:block">
               <img src="https://cdn-icons-png.flaticon.com/512/4151/4151113.png" alt="Truck" className="w-64 h-64 object-contain opacity-20" />
            </div>
         </div>
         <div className="absolute bottom-0 left-0 w-full h-12 bg-white rounded-t-[3rem]"></div>
      </div>

      {/* 2. SERVICE SELECTION TITLE */}
      <div className="text-center py-10">
        <h2 className="text-2xl font-black text-slate-800 tracking-tight">Select a Special Shipping Service Category</h2>
      </div>

      {/* 3. SERVICES GRID */}
      <section className="max-w-7xl mx-auto px-6 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {specialServices.map((s) => (
            <div key={s.id} className="bg-white border border-slate-100 rounded-3xl p-6 shadow-sm hover:shadow-xl transition-all group text-center flex flex-col items-center">
              <div className="mb-4 p-4 rounded-2xl bg-slate-50 group-hover:scale-110 transition-transform">
                {s.icon}
              </div>
              <h3 className="font-black text-lg text-slate-800 mb-2">{s.title}</h3>
              <p className="text-slate-400 text-xs font-bold mb-6">{s.desc}</p>
 
              {s.id === 1 ? (
                <button 
                  onClick={() => navigate('/cold-chain')}
                  className="w-full bg-orange-500 text-white py-3 rounded-xl font-black uppercase text-[10px] tracking-widest hover:bg-orange-600 transition shadow-lg shadow-orange-100 cursor-pointer"
                >
                  {s.tag}
                </button>
              ) : s.id === 2 ? (
                <button 
                  onClick={() => navigate('/pharma-cold-chain')}
                  className="w-full bg-orange-500 text-white py-3 rounded-xl font-black uppercase text-[10px] tracking-widest hover:bg-orange-600 transition shadow-lg shadow-orange-100 cursor-pointer"
                >
                  {s.tag}
                </button>
              ) : s.id === 3 ? (
                <button 
                  onClick={() => navigate('/fragile-item-shipping')}
                  className="w-full bg-orange-500 text-white py-3 rounded-xl font-black uppercase text-[10px] tracking-widest hover:bg-orange-600 transition shadow-lg shadow-orange-100 cursor-pointer"
                >
                  {s.tag}
                </button>
              ) : s.id === 4 ? (
                <button 
                  onClick={() => navigate('/heavy-machinery-transport')}
                  className="w-full bg-orange-500 text-white py-3 rounded-xl font-black uppercase text-[10px] tracking-widest hover:bg-orange-600 transition shadow-lg shadow-orange-100 cursor-pointer"
                >
                  {s.tag}
                </button>
              ) : s.id === 5 ? (
                <button 
                  onClick={() => navigate('/dangerous-goods-transport')}
                  className="w-full bg-orange-500 text-white py-3 rounded-xl font-black uppercase text-[10px] tracking-widest hover:bg-orange-600 transition shadow-lg shadow-orange-100 cursor-pointer"
                >
                  {s.tag}
                </button>
              ) : (
                <button 
                  onClick={() => handleSpecialBooking(s.title)}
                  className="w-full bg-orange-500 text-white py-3 rounded-xl font-black uppercase text-[10px] tracking-widest hover:bg-orange-600 transition shadow-lg shadow-orange-100 cursor-pointer"
                >
                  {s.tag}
                </button>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* 4. DETAILED INFORMATION SECTION */}
      <section className="max-w-5xl mx-auto px-6 pb-20">
        <div className="space-y-12">
          {[
            { title: "Cold Chain Logistics", desc: "Keep your perishables fresh and intact with our advanced temperature-controlled transport solutions. We leverage cutting-edge refrigeration technology to ensure the perfect environment for your sensitive goods from origin to destination, maintaining quality at every step." },
            { title: "Medicine Transport", desc: "Trust in our specialized care for life-saving pharmaceuticals and vaccines. Our dedicated team follows rigorous safety protocols and climate-controlled handling procedures to ensure your vital medicine arrives safely, securely, and right on time." },
            { title: "Fragile Item Shipping", desc: "Handle your delicate and valuable goods with absolute precision. We combine protective packaging expertise with gentle, secure handling techniques to minimize risk and ensure your fragile items reach their destination in pristine condition." },
            { title: "Heavy Machinery Transport", desc: "Move complex, oversized, and heavy industrial equipment with confidence. Our team offers specialized logistics planning, expert loading services, and robust transport solutions to ensure the safe, efficient, and reliable delivery of your heaviest assets." },
            { title: "Dangerous Goods Transport", desc: "Safety is our top priority when handling hazardous materials. With certified, experienced personnel and fully compliant protocols, we provide secure and reliable transport solutions tailored to the strict regulatory requirements of dangerous goods." }
          ].map((item, index) => (
            <div key={index} className="border-l-4 border-orange-500 pl-6 hover:bg-slate-50 p-4 transition-all rounded-r-2xl">
              <h4 className="text-xl font-black text-slate-800 mb-2">{item.title}</h4>
              <p className="text-slate-600 font-medium leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 5. CALL TO ACTION (Bottom Blue Bar) */}
      <div className="max-w-6xl mx-auto mb-20 px-4">
        <div className="bg-[#002D5E] rounded-[2.5rem] p-8 md:p-12 flex flex-col md:flex-row items-center justify-between text-white shadow-2xl relative overflow-hidden">
          <div className="flex items-center gap-6 relative z-10 text-center md:text-left flex-col md:flex-row">
            <div className="bg-white/10 p-4 rounded-full">
               <ShieldCheck size={50} className="text-orange-400" />
            </div>
            <div>
              <h3 className="text-2xl font-black mb-2">Reliable & Secure Transportation for Sensitive Shipments!</h3>
              <p className="text-blue-100/70 font-bold uppercase tracking-widest text-xs">Request a Customized Logistics Solution Today!</p>
            </div>
          </div>
 
          <button 
            onClick={() => handleSpecialBooking("Special Handling Quote Request")}
            className="bg-orange-500 text-white w-full md:w-auto px-6 sm:px-10 py-4 sm:py-5 rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-orange-600 transition shadow-xl mt-8 md:mt-0 relative z-10 cursor-pointer"
          >
            Get a Quote!
          </button>
        </div>
      </div>

      {/* 6. FINAL BRANDED TRUCK IMAGE SECTION */}
      <div 
        className="w-full h-[280px] sm:h-[400px] md:h-[550px] flex items-start justify-center text-center pt-10 md:pt-[60px] relative overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('/truck-bg.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#002D5E'
        }}
      >
        <div className="max-w-5xl px-6 relative z-10">
          <h2 className="text-white text-2xl sm:text-4xl md:text-6xl font-[950] uppercase tracking-wide md:tracking-[3px] drop-shadow-[0_4px_20px_rgba(0,0,0,0.9)] leading-tight">
            One Solution for All Logistics
          </h2>
        </div>
      </div>

    </div>
  );
};

export default SpecialLogistics;